import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from "src/@/components/ui/card";
import { Label } from "src/@/components/ui/label";
import { Button } from "src/@/components/ui/button";
import Iconify from 'src/components/Iconify';
import VariableInput from "./VariableInput";
import { Input } from 'src/@/components/ui/input';

const FlowStateBuilder = ({ flowState = [], onChange, availableVariables = [], currentNodeVariables = [] }) => {
    const { t } = useTranslation('automation');

    const handleAddState = () => {
        const newStates = [...flowState, { key: '', value: '' }];
        onChange(newStates);
    };

    const handleRemoveState = (index) => {
        const newStates = flowState.filter((_, i) => i !== index);
        onChange(newStates);
    };

    const handleStateChange = (index, field, value) => {
        const newStates = [...flowState];
        newStates[index] = { ...newStates[index], [field]: value };
        onChange(newStates);
    };

    return (
        <div className="space-y-4 pt-4 border-t">
            <div className="flex items-center gap-2 mb-2">
                <Label className="text-sm font-semibold text-gray-700">{t('flowState.title', 'Atualizar Estado do Fluxo')}</Label>
                <Iconify icon="mdi:information-outline" className="text-gray-400" width={16} />
            </div>

            <div className="space-y-3">
                {flowState.map((state, index) => (
                    <Card key={index} className="p-4 bg-white border border-gray-200 shadow-sm relative">
                        <div className="flex justify-between items-start mb-2">
                            <div className="space-y-1 w-full mr-12">
                                <div className="flex gap-1">
                                    <Label className="text-xs font-semibold text-gray-600">{t('flowState.keyLabel', 'Chave (Key)')}</Label>
                                    <span className="text-red-500 text-xs">*</span>
                                </div>
                                <Input
                                    value={state.key}
                                    onChange={(e) => handleStateChange(index, 'key', e.target.value)}
                                    className="h-9 bg-white"
                                    placeholder={t('flowState.keyPlaceholder', 'Ex: resultado')}
                                />
                                {/* <VariableInput
                                    value={state.key}
                                    onChange={(e) => handleStateChange(index, 'key', e.target.value)}
                                    className="h-9 bg-white"
                                    placeholder="Ex: resultado"
                                    variables={availableVariables.filter(v => v.type === 'Flow State')}
                                /> */}
                            </div>

                            <div className="absolute top-4 right-4 flex items-center gap-2">
                                <span className="bg-gray-100 text-gray-500 text-[10px] px-2 py-0.5 rounded-full font-mono">{index}</span>
                                <Button
                                    variant="ghost"
                                    size="icon"
                                    className="h-7 w-7 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-md transition-colors"
                                    onClick={() => handleRemoveState(index)}
                                >
                                    <Iconify icon="mdi:trash-can-outline" width={16} />
                                </Button>
                            </div>
                        </div>

                        <div className="space-y-1 mt-3">
                            <div className="flex items-center justify-between">
                                <div className="flex gap-1">
                                    <Label className="text-xs font-semibold text-gray-600">{t('flowState.valueLabel', 'Valor (Value)')}</Label>
                                    <span className="text-red-500 text-xs">*</span>
                                </div>
                                <span className="text-[10px] text-emerald-600 font-medium cursor-help" title={t('flowState.valueHint', 'Use variáveis/funções')}>(x)</span>
                            </div>
                            <VariableInput
                                value={state.value}
                                onChange={(e) => handleStateChange(index, 'value', e.target.value)}
                                className="h-9 bg-white"
                                placeholder={t('flowState.valuePlaceholder', 'Ex: {{output.result}}')}
                                variables={[...currentNodeVariables, ...availableVariables]}
                            />
                        </div>
                    </Card>
                ))}
            </div>

            <Button
                variant="outline"
                className="w-full border-dashed border-blue-300 text-blue-600 hover:bg-blue-50 mt-2"
                onClick={handleAddState}
            >
                <Iconify icon="mdi:plus" className="mr-2" width={16} />
                {t('flowState.addButton', 'Adicionar Estado')}
            </Button>
        </div>
    );
};

export default FlowStateBuilder;
